import { render, staticRenderFns } from "./PatientsFilterEditor.vue?vue&type=template&id=e56aa246&"
import script from "./PatientsFilterEditor.vue?vue&type=script&lang=tsx&"
export * from "./PatientsFilterEditor.vue?vue&type=script&lang=tsx&"
import style0 from "./PatientsFilterEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports